import React from "react";

import ChapterAlignment from "pages/customer/tools/location/filters/targets/ChapterAlignment";

import NumberOfStores from "./NumberOfStores";
import BrandPositioning from "./BrandPositioning";

import {
    selectCandidateTarget,
    selectDefaultTarget,
    setCandidateTarget
} from "modules/customer/tools/location/filters/filtersSlice";
import { useAppDispatch, useAppSelector } from "store";
import { Divider, withStyles } from "@material-ui/core";

const StyledDivider = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.background.insight
    }
}))(Divider);

const Retailers: React.FC = () => {
    const dispatch = useAppDispatch();
    const candidateTarget = useAppSelector(selectCandidateTarget);
    const defaultTarget = useAppSelector(selectDefaultTarget);
    const resetButtonDisabled = !candidateTarget
        || !defaultTarget
        || candidateTarget.numberOfStores === defaultTarget.numberOfStores;

    const handleResetButtonClick = () => {
        if (candidateTarget && defaultTarget) {
            const newCandidateTarget = {
                ...candidateTarget,
                numberOfStores: defaultTarget.numberOfStores
            };
            dispatch(setCandidateTarget(newCandidateTarget));
        }
    };

    const handleSwitchChange = () => {
        if (candidateTarget) {
            const newCandidateTarget = {
                ...candidateTarget,
                useRetailers: !candidateTarget.useRetailers
            };
            dispatch(setCandidateTarget(newCandidateTarget));
        }
    };

    if (!candidateTarget) {
        return null;
    }

    return (
        <ChapterAlignment
            name="Retailers"
            disabled={!candidateTarget.useRetailers}
            resetButtonDisabled={resetButtonDisabled}
            onResetButtonClick={handleResetButtonClick}
            onSwitchChange={handleSwitchChange}
        >
            <NumberOfStores />
            <StyledDivider />
            <BrandPositioning />
        </ChapterAlignment>
    );
};

export default Retailers;
